import React, { useMemo, useEffect, useCallback } from 'react'
import { useTable, useRowSelect } from 'react-table'
import { FixedSizeList } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import UserItem from './QuitTableItem'
import Checkbox from '../../Radio'

const QuitUserTable = function ({ users, updateToUserId }) {
  const datas = useMemo(() => users || [], [users])
  const columns = useMemo(
    () => [
      {
        id: 'name',
        Header: '用户姓名',
        accessor: 'name',
      },
      {
        id: 'username',
        Header: '用户名',
        accessor: 'username',
      },
      {
        id: 'mobile',
        Header: '手机号',
        accessor: 'mobile',
      },
      {
        id: 'org',
        Header: '组织',
        accessor: 'org',
      },
      {
        id: 'role',
        Header: '角色',
        accessor: 'role',
      },
    ],
    []
  )
  const tableInstance = useTable(
    { columns, data: datas },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push(() => [
        {
          id: 'selection',
          width: 50,
          // eslint-disable-next-line react/no-unstable-nested-components
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <Checkbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // eslint-disable-next-line react/no-unstable-nested-components
          Cell: ({ row }) => (
            <div>
              <Checkbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ])
    }
  )
  const {
    getTableProps,
    getTableBodyProps,
    rows,
    prepareRow,
    selectedFlatRows,
  } = tableInstance
  useEffect(() => {
    const checkedUsers = selectedFlatRows.map((d) => d.original)
    if (checkedUsers.length > 0) {
      updateToUserId(checkedUsers[0].id)
    }
  }, [selectedFlatRows])

  const renderRow = useCallback(
    ({ index, style }) => {
      const row = rows[index]
      prepareRow(row)
      return (
        <UserItem
          style={style}
          // selectedUsers={selectedFlatRows.map((d) => d.original)}
          key={row.original.id}
          row={row}
        />
      )
    },
    [prepareRow, rows, selectedFlatRows]
  )
  return (
    <div className="rounded-md">
      <div
        {...getTableProps()}
        className="w-full overflow-x-auto sm:overflow-x-visible"
      >
        {/* <thead>
          {headerGroups.map((headerGroup) => {
            return (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                key={headerGroup.headers}
                className="flex text-gray-700 border-b border-gray-200 px-5 py-3"
              >
                {headerGroup.headers.map((column) => {
                  return (
                    <th
                      {...column.getHeaderProps()}
                      key={column.id}
                      className={`${
                        // eslint-disable-next-line no-nested-ternary
                        column.id === 'selection' ? 'mr-5 ' : 'w-1/5 '
                      }flex items-center`}
                    >
                      {column.render('Header')}
                    </th>
                  )
                })}
              </tr>
            )
          })}
        </thead> */}
        <div
          {...getTableBodyProps()}
          className="overflow-y-auto content block"
          style={{ height: '30rem' }}
        >
          <AutoSizer>
            {({ height, width }) => {
              return (
                <FixedSizeList
                  height={height}
                  itemCount={rows.length}
                  itemSize={50}
                  width={width}
                >
                  {renderRow}
                </FixedSizeList>
              )
            }}
          </AutoSizer>
        </div>
      </div>
    </div>
  )
}

export default QuitUserTable
